import { Component, OnInit, Input, Output, EventEmitter, ElementRef, HostListener } from '@angular/core';
import { KeyValueId, KeyValues3, KeyValueSet, LocalService } from '../../../service/local.service';

@Component({
  selector: 'app-list-options',
  templateUrl: './list-options.component.html',
  styleUrls: ['./list-options.component.scss']
})
export class ListOptionsComponent implements OnInit {
  @Input() items: KeyValueSet[]; @Input() itemsWithCode: KeyValues3[]; @Input() selectedKey = ''; @Input() isShowEquivalentLanguage = false; @Input() isDisabled = false;
  @Output() onSelectionChanged = new EventEmitter(); @Input() Title = ''; @Input() isBannerType = true; @Input() isMultiSelect = false; @Output() onSelectionRemoved = new EventEmitter(); @Input() isRemoveRequired = false;
  @Output() itemsChange = new EventEmitter<any>();
  @Output() onFocusOut = new EventEmitter<any>();

  constructor(public localService: LocalService, private elementRef: ElementRef) { }

  ngOnInit(): void {
    this.onChange(this.selectedKey, false);

  }

  onChange(id, isEmit = true) {
    if (!this.isMultiSelect && !(this.selectedKey && this.selectedKey.length > 0)) {
      const item = this.items.find(x => x.isSelected == true);
      if (item) {
        this.selectedKey = item.key;
        id = item.key;
      }
    }

    if (!this.isMultiSelect) {
      if (this.items) {
        const lastSelection = this.isRemoveRequired && this.items && this.items.filter(x => x.isSelected).length > 0 ? JSON.parse(JSON.stringify(this.items.find(x => x.isSelected))) : undefined;
        this.items.forEach(x => x.isSelected = false);
        if (id != '') {
          if (this.isRemoveRequired && isEmit && lastSelection && lastSelection.key == id && lastSelection.isSelected) {
            this.items.find(x => x.key == id).isSelected = false;
            this.onSelectionRemoved.emit(id);
          } else {
            this.items.find(x => x.key == id).isSelected = true;
            if (isEmit) {
              this.onSelectionChanged.emit(id);
            }
          }
        }
      }

      if (this.itemsWithCode) {
        const lastSelection = this.isRemoveRequired && this.itemsWithCode && this.itemsWithCode.filter(x => x.isSelected).length > 0 ? JSON.parse(JSON.stringify(this.itemsWithCode.find(x => x.isSelected))) : undefined;
        this.itemsWithCode.forEach(x => x.isSelected = false);
        if (id != '') {
          if (this.isRemoveRequired && isEmit && lastSelection && lastSelection.key == id && lastSelection.isSelected) {
            this.itemsWithCode.find(x => x.key == id).isSelected = false;
            this.onSelectionRemoved.emit(id);
          } else {
            this.itemsWithCode.find(x => x.key == id).isSelected = true;
            if (isEmit) {
              this.onSelectionChanged.emit(id);
            }
          }
        }
      }
    } else {
      if (isEmit) {
        let item = this.items ? this.items.find(x => x.key == id) : this.itemsWithCode.find(x => x.key == id);
        if (item) {
          item.isSelected = !item.isSelected;
          const ids = this.items ? this.items.filter(x => x.isSelected).map(x => x.key) : this.itemsWithCode.filter(x => x.isSelected).map(x => x.key);
          this.onSelectionChanged.emit(ids);
        }
      }
    }
  }

  @HostListener('document:click', ['$event'])
  onClick(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      const targetElement = event.target as HTMLElement;
      if (!this.elementRef.nativeElement.contains(targetElement)) {
        this.onFocusOut.emit(targetElement.className); // Emit class name
      }
    }
  }
}
